import React from "react";
import { Box } from "@mui/material";

// A bot log entry starts with "2025-10-21 15:37:18,601 - LEVEL - logger - ...";
// its wrapped continuation lines (total/downloaded/uploaded) carry no header.
const ENTRY_HEADER = /^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2},\d+ - )(\S+)( - )/;

const LEVEL_COLORS: Record<string, string> = {
  SUCCESS_INFO: "success.main",
  ERROR: "error.main",
  CRITICAL: "error.main",
  WARNING: "warning.main",
  DEBUG: "text.disabled",
};

/**
 * Colors bot status/file logs by log level so the eye can separate the
 * successes from the failures. Continuation lines inherit the color of the
 * entry they belong to; timestamps stay muted. Renders spans meant to live
 * inside the existing <pre> viewers.
 */
const ColorizedLogText = React.memo(function ColorizedLogText({
  text,
}: {
  text: string;
}) {
  const lines = text.split("\n");
  let currentColor = "text.primary";
  return (
    <>
      {lines.map((line, index) => {
        const suffix = index < lines.length - 1 ? "\n" : "";
        const header = ENTRY_HEADER.exec(line);
        if (header) {
          currentColor = LEVEL_COLORS[header[2]] ?? "text.primary";
          return (
            <React.Fragment key={index}>
              <Box component="span" sx={{ color: "text.secondary" }}>
                {header[1]}
              </Box>
              <Box component="span" sx={{ color: currentColor }}>
                {line.slice(header[1].length) + suffix}
              </Box>
            </React.Fragment>
          );
        }
        return (
          <Box key={index} component="span" sx={{ color: currentColor }}>
            {line + suffix}
          </Box>
        );
      })}
    </>
  );
});

export default ColorizedLogText;
